import { FieldProps } from 'formik'
import React from 'react'
import { Button, Element } from 'react-bulma-components'
import FormField, { FormFieldProps } from './form-field'

export interface YesNoButtonsFieldProps extends FormFieldProps, FieldProps {}

const YesNoButtonsField: React.FunctionComponent<YesNoButtonsFieldProps> = props => {
  const { field, form, label, help, ...rest } = props

  const handleYesClick = () => {
    field.onChange({ target: { name: field.name, value: 'yes' } })
  }

  const handleNoClick = () => {
    field.onChange({ target: { name: field.name, value: 'no' } })
  }

  return (
    <FormField label={label} help={help} error={form.errors[field.name] as string}>
      <Element>
        <Button.Group>
          <Button
            color={field.value === 'yes' ? 'primary' : 'light'}
            onClick={handleYesClick}
            type="button"
            data-testid="yesno-yes"
          >
            Oui
          </Button>
          <Button
            color={field.value === 'no' ? 'primary' : 'light'}
            onClick={handleNoClick}
            type="button"
            data-testid="yesno-no"
          >
            Non
          </Button>
        </Button.Group>
      </Element>
    </FormField>
  )
}

export default YesNoButtonsField
